<div class="card mt-3">
    <div class="card-body" [formGroup]="form">
        <div class="row">
            <div class="col-md-8">
                <h5 class="card-title main-blue">
                    {{ "CampDetails.DayVariantsTitle" | translate }}
                </h5>
            </div>
            <div class="col-md-4">
                @if (state.canEdit | async) {
                    <button
                        class="btn btn-success btn-action pull-right"
                        [disabled]="isAnyItemEdited"
                        hznTestId="day-variants-add"
                        (click)="add()"
                    >
                        {{ "General.Add" | translate }}
                    </button>
                }
            </div>
        </div>

        @for (dayVariant of form.controls.items["controls"]; track dayVariant) {
            <div>
                @if (!isEdited(dayVariant)) {
                    <app-day-variant-details
                        [form]="dayVariant"
                        (removed)="onRemoved($event)"
                    ></app-day-variant-details>
                }
                @if (isEdited(dayVariant)) {
                    <app-day-variant-details-edit
                        [form]="dayVariant"
                        (canceled)="onCancel($event)"
                    ></app-day-variant-details-edit>
                }
            </div>
        }
    </div>
</div>
